import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroBanner from './components/HeroBanner';
import SalesVoucher from './components/SalesVoucher'; 
import StockIn from './components/StockIn'; 
import CustomersManager from './components/CustomersManager';
import SalesRegister from './components/SalesRegister';
import TagwiseStock from './components/TagwiseStock';
import Collection from './components/Collection'; 
import ReceiptVoucher from './components/ReceiptVoucher';
import ReceiptRegister from './components/ReceiptRegister'; 
import ItemMasterSettings from './components/ItemMasterSettings';
import EnquiryDashboard from './components/EnquiryDashboard';
import AboutUs from './components/AboutUs';
import PrintPreview from './components/PrintPreview';
import SalesReturn from './components/SalesReturn';

// 🔑 Naya Login Component Import Kiya
import Login from './components/Login'; 
import './App.css';

function App() {
  // Check karenge ki user pehle se logged in hai ya nahi
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState('');

  useEffect(() => {
    const token = sessionStorage.getItem('accessToken');
    const role = sessionStorage.getItem('userRole');
    const manualLogout = sessionStorage.getItem('manual_logout'); // 🛑 Naya flag
  //   if (token && role) {
  //     setIsAuthenticated(true);
  //     setUserRole(role);
  //   }
  // }, []);
      // 🔍 FIXED: Agar role 'Guest' hai toh bina token ke bhi session active rakhein
    if (role === 'Guest' || (token && role)) {
      setIsAuthenticated(true);
      setUserRole(role);
    }
  // 🔄 AUTO GUEST LOGIN: Agar logged in nahi hai AUR user ne khud logout nahi kiya hai
    else if (manualLogout !== 'true') {
      sessionStorage.setItem('userRole', 'Guest');
      sessionStorage.setItem('username', 'Customer');
      setIsAuthenticated(true);
      setUserRole('Guest');
    }
  }, []);

  // 🚪 Log Out karne ka function
  const handleLogout = () => {
    sessionStorage.clear(); // Purana data hata dega
    sessionStorage.setItem('manual_logout', 'true'); // 🛑 Nayi line: Manual logout ka nishan set karega
    setIsAuthenticated(false);
    setUserRole('');
  };

  const handleLoginSuccess = (role) => {
    setIsAuthenticated(true);
    setUserRole(role);
  };

  // 🚪 Log Out karne ka function (ise baad me navbar me jodenge)
  // const handleLogout = () => {
  //   sessionStorage.clear();
  //   setIsAuthenticated(false);
  //   setUserRole('');
  // };

  // 🛡️ Agar logged in nahi hai, toh sirf Login form dikhao
  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="App">
      {/* Navbar ko logout handle karne ki power de rahe hain */}
      <Navbar onLogout={handleLogout} role={userRole} />
      
      <Routes>
        <Route path="/" element={<HeroBanner />} />
        <Route path="/collection" element={<Collection />} />        
        
        {/* 📋 Naya Admin/Manager Enquiry Dashboard Route */}
        <Route path="/admin/enquiries" element={<EnquiryDashboard />} />

        {/* 🔒 PROTECTED ROUTE: Customers page ab sirf Admin aur Manager khol sakte hain, Guest nahi */}
        <Route path="/Customers" element={userRole !== 'Guest' ? <CustomersManager /> : <Navigate to="/" />} />

        {/* 🔒 Baki protected routes bhi ekdum clean normal style me hain */}
        <Route path="/sales" element={userRole !== 'Guest' ? <SalesVoucher /> : <Navigate to="/" />} />
        <Route path="/stockin" element={userRole !== 'Guest' ? <StockIn /> : <Navigate to="/" />} />
        <Route path="/sales-register" element={userRole !== 'Guest' ? <SalesRegister /> : <Navigate to="/" />} />
        <Route path="/tagwise-stock" element={userRole !== 'Guest' ? <TagwiseStock /> : <Navigate to="/" />} />
        <Route path="/receipt-voucher" element={userRole !== 'Guest' ? <ReceiptVoucher /> : <Navigate to="/" />} />
        <Route path="/receipt-register" element={userRole !== 'Guest' ? <ReceiptRegister /> : <Navigate to="/" />} />
        <Route path="/sales-return" element={userRole !== 'Guest' ? <SalesReturn /> : <Navigate to="/" />} />

        {/* 👑 STRICT ADMIN ROUTE: Only Admin */}
        <Route path="/master-settings" element={userRole === 'Admin' ? <ItemMasterSettings /> : <Navigate to="/" />} />
        
        <Route path="*" element={<Navigate to="/" />} />

        <Route path="/admin/enquiries" element={<EnquiryDashboard />} />

        <Route path="/about" element={<AboutUs />} />
        <Route path="/print-preview" element={userRole !== 'Guest' ? <PrintPreview /> : <Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;